import React from 'react';
import { Outlet } from 'react-router-dom';
import { useUser } from '@lore/auth';
import NotFoundPage from '@/pages/NotFoundPage';
import isStaffUser from '../isStaffUser';

/**
 * Route guard for staff-only pages. Non-staff users get the regular 404 page
 * in place, so the URL does not reveal that a staff page exists here.
 * The backend enforces the same rule (403 for non-staff) on every /staff call.
 */
export default function StaffOnly() {
  const currentUser = useUser();

  if (!isStaffUser(currentUser)) {
    return <NotFoundPage />;
  }

  return <Outlet />;
}
